/*
 * File: input-table.ts
 * File Created: 2024-11-11 09:13:23
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-23 05:17:17
 * Modified By: Val Liu
 * -----
 */

import { PropInnateSync } from "@root/core/vue-props";
import { BaseInputComponent } from "../../core/lib";
import { Component, Emit, MetaAttribute, Prop } from "@root/core";
import { IUITagResult } from "@root/core/tags";
import { BaseTableCore } from "@root/components/table/core/lib/base-table-core";

@Component
export default class InputTable extends BaseInputComponent {
    @PropInnateSync("value", { type: Array, default: () => [] })
    declare innateValue: Array<any>;

    @Prop({ type: Object, required: true })
    meta!: MetaAttribute;

    /// get the tag "specials"
    @Prop({ type: Object, required: false })
    specials?: IUITagResult["specials"];

    @Emit("added")
    doAdd(row) {
        this.innateValue = [...(this.innateValue ?? []), row];
        return row;
    }

    @Emit("updated")
    doEdit(row, old) {
        const index = this.innateValue.findIndex(
            (o) => BaseTableCore.getDataId(o) === BaseTableCore.getDataId(old ?? row),
        );
        this.innateValue = [
            ...this.innateValue.slice(0, index),
            row,
            ...this.innateValue.slice(index + 1),
        ];
        return row;
    }

    @Emit("deleted")
    doDelete(row) {
        const index = this.innateValue.findIndex(
            (o) => BaseTableCore.getDataId(o) === BaseTableCore.getDataId(row),
        );
        this.innateValue = [
            ...this.innateValue.slice(0, index),
            ...this.innateValue.slice(index + 1),
        ];
        return row;
    }

    /// private helpers
    // interfaces
    get infs() {
        return {
            base: this.meta.attr.type.data,
            ...this.specials?.CRUDType,
        };
    }
}
